<template>
		<v-card-text v-if="isSubscriptionActive" class="narrow-container">
            <span class="onboarding-title d-block text-center mb-12">Account setup</span>
            <span class="onboarding-text d-block mb-5">
                fylm.ai uses organizations to help you keep your workflow organized.
                You can always change organization name from your account settings.
            </span>

            <v-text-field
                v-model="form.name"
                :error-messages="form.$errors.name"
                label="Your organization name, e.g. ACME Company"
                outlined
                @blur="form.validate('name')"
                @input="delete form.$errors.name"
            />

            <v-btn color="primary" large depressed block rounded @click="onSubmit">
                Create organization
            </v-btn>
		</v-card-text>

		<div v-else class="activating-subscription-container mt-10">
			<v-progress-circular indeterminate color="var(--primary)" size="50" width="5"></v-progress-circular>
			<span class="onboarding-text">{{ actionMessage }}</span>
		</div>
</template>

<script>
import { mapActions, mapGetters, mapState } from "vuex";
import * as rules from "vuelidate/lib/validators";

export default {
	data() {
		return {
			submitted: false,
			form: new Form(this, "form", {
				name: null,
			}),
			fetchCurrentPlanInterval: null,
			actionMessage: "Activating your subscription",
		};
	},
	validations: {
		form: {
			name: { required: rules.required },
		},
	},
	computed: {
		...mapState("User", ["account", "currentPlan"]),
		...mapState('Plans', ['PLAN_FREE', 'PLAN_PRO', 'PLAN_PRO_YEARLY']),
		...mapGetters("User", ["user"]),
		isSubscriptionActive() {
			if (this.account.plan_id == 1) return true;
			else if (this.currentPlan) return this.currentPlan.fastspring.active;
			else return false;
		},
	},

	created() {
		if (this.account.plan_id == 1) return;

		setTimeout(() => {
			this.actionMessage = "Hang on tight, we're nearly done";
			setTimeout(() => {
				this.actionMessage = "Performing some last touches";
				setTimeout(() => {
					this.actionMessage = "Syncing everything with payment processor";
				}, 10000);
			}, 10000);
		}, 10000);

		this.fetchCurrentPlanInterval = setInterval(async () => {
			await this.$store.dispatch("User/fetchCurrentPlan");
			if (this.isSubscriptionActive) clearInterval(this.fetchCurrentPlanInterval);
		}, 3000);
	},

	methods: {
		...mapActions("User", ["fetchUser"]),

		async onSubmit() {
			if (!this.form.validate()) {
				return;
			}

			await this.$apiService.post(`accounts/${this.account.id}/organizations`, this.form);

			this.submitted = true;
            await this.fetchUser();

            if ([this.PLAN_FREE.id, this.PLAN_PRO.id, this.PLAN_PRO_YEARLY.id].includes(this.account.plan_id)) {
                this.$router.push({
                    name: "app",
                });
            } else {
				this.$router.push({
					name: "onboarding.invite",
					params: { canSkip: true },
				});
			}
		},
	},
};
</script>

<style lang="scss" scoped>
.activating-subscription-container {
    display: flex;
    flex-direction: column;
    align-items: center;

    > span {
        margin-top: 15px;
    }
}
</style>
